import SERVER_URL from '@/config'

const feathers = require('@feathersjs/feathers')
const rest = require('@feathersjs/rest-client')
const auth = require('@feathersjs/authentication-client')

const app = feathers()

// Connect to a different URL
const restClient = rest(SERVER_URL)

// Configure an AJAX library (see below) with that client
app.configure(restClient.fetch(window.fetch.bind(window)))

app.configure(auth({
  storageKey: 'cns-auth',
  timeout: 60 * 1000
}))

export default app
